import './car-card.css';
import React from 'react';
import {HomeGameCardItem} from '@/pages/home/home.type';
import globalStore from '@services/global.state';
import {normalizeGamePush} from '@utils/game';
import BaseImageCard from './base-image-card';

const CarCards = ({
  v,
}: {
  i: number;
  v: HomeGameCardItem;
  serverTime?: number;
  currentTime?: number;
}) => {
  // const {toGame} = useGameNavitate();

  return (
    <BaseImageCard
      imageUrl={v.otherUrl || v.gamePic}
      onClick={() => {
        globalStore.updateAmount.next({gameType: 'QuickRace'});
        normalizeGamePush(v.id, true);
      }}
    />
  );
};

export default CarCards;
